// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-TW0Q","questions":"styles_questions__2mKNV","footer":"styles_footer__3zu9s"};